export default function (dom, opts) {
    let options = {
        showOverlay: 'contact-overlay',
				selectionTextSel: '[name="wizardselection"]',
        productNameFormSel: '[name="productname"]',
        productNameBtnSel: '[data-query]',
        productOfferTitleSel: '[data-product-offer-title]',
				frequencyInverterWizard: false,
        ...opts
    };

    const html = document.documentElement;
    const productNameInForm = html.querySelector(options.productNameFormSel);
    const askAboutBtn = dom.querySelector(options.productNameBtnSel);
    const offerTitle = document.querySelector(options.productOfferTitleSel);
		const selectionText = document.querySelector(options.selectionTextSel);


    function init() {
        inquireProduct();
    }

    function inquireProduct() {
        askAboutBtn.addEventListener('click', openAndName)
    }

    function openAndName() {
        html.classList.add(options.showOverlay);
        offerTitle.innerHTML = offerTitle.getAttribute('data-product-offer-title');

        if (askAboutBtn.dataset.product.length > 0) {
          productNameInForm.value = askAboutBtn.dataset.product;
        }

				if (selectionText && askAboutBtn.dataset.selectiontext.length > 0 ) {
					selectionText.value = askAboutBtn.dataset.selectiontext;
				}

				if (options.frequencyInverterWizard) {
					let msgBox = document.querySelector(".contact-overlay-box__support");
					msgBox.innerHTML = msgBox.getAttribute("data-frequency-title");
				}
    }

    init();

}
